export function update(collection: Array<any>, updatedObject: any, idColumn: string) {
  let mergedCollection;
  const index = collection.findIndex(x => x[idColumn] === updatedObject[idColumn]);
  if (index === 0) {
    mergedCollection = [updatedObject, ...collection.slice(1, collection.length)];
  } else {
    mergedCollection = [
      ...collection.slice(0, index),
      updatedObject,
      ...collection.slice(index + 1, collection.length)
    ];
  }
  return mergedCollection;
}

export function remove(collection: Array<any>, updatedObject: any, idColumn: string) {
  let mergedCollection;
  const index = collection.findIndex(x => x[idColumn] === updatedObject[idColumn]);
  if (index === 0) {
    mergedCollection = [...collection.slice(1, collection.length)];
  } else {
    mergedCollection = [
      ...collection.slice(0, index),
      ...collection.slice(index + 1, collection.length)
    ];
  }
  return mergedCollection;
}